import { Splide } from '@splidejs/splide';

/**
 * SlidePrecedent
 * カードを「SP=スワイプスライダー / PC=destroyして素のDOM（CSS側でグリッド/縦積み）」に切り替える。
 * SlidePoints と同方式：mediaQuery:'min' ＋ breakpoints{768:{destroy:true}} で、≥768 では破棄される。
 * 複数インスタンス対応。挙動は data 属性で上書き可：
 *   data-fixed-width（既定 29.5rem）／data-gap（既定 2.4rem）
 *   data-arrows="false"（アロー非表示）／data-pagination="true"（インジケータ表示）
 *
 * @example
 * <div class="p-precedent-cards splide js-slide-precedent">…</div>                          // 事例（アロー）
 * <div class="p-industry-cards splide js-slide-precedent" data-arrows="false" data-pagination="true" data-gap="1.6rem">…</div> // 業界（インジケータ）
 */
export default class SlidePrecedent {
  constructor(options = {}) {
    this.selector = options.selector || '.js-slide-precedent';
    document.querySelectorAll(this.selector).forEach((el) => this.setup(el));
  }

  /**
   * @param {HTMLElement} el
   */
  setup(el) {
    try {
      const slideCount = el.querySelectorAll('.splide__slide').length;
      const splide = new Splide(el, {
        mediaQuery: 'min',
        type: 'loop',
        perPage: 1,
        focus: 'center',                          // 中央カード＋両隣ちら見（デザイン）
        fixedWidth: el.dataset.fixedWidth || '29.5rem',
        gap: el.dataset.gap || '2.4rem',
        arrows: el.dataset.arrows !== 'false',
        pagination: el.dataset.pagination === 'true' && slideCount > 1, // 1枚のときはインジケータ非表示
        drag: true,
        breakpoints: {
          768: { destroy: true }, // ≥768 はスライダー解除（CSSで縦積み/グリッド）
        },
      });
      splide.mount();
    } catch (error) {
      console.error('SlidePrecedent: Failed to initialize Splide', error);
    }
  }
}
